import $ from 'cash-dom'
import { buildReviews } from './yotpo-ratings'
import {
  getKlevuCollection,
  getProductRecommendations,
} from '../resources/klevu-api'
import { addToCartButton } from './product-form'
import { productGrid } from '../templates/klevu-product-grids'
import { getKlevuBadge, getKlevuCategoryBadge } from './klevu-badges'
import { buildLazyLoad } from './video'
import { productPricing } from './product-pricing'
import { QuickView } from './quick-view'
import { parseFilters } from '../utilities/filters.ts'
import { getPoogleRecommendations } from '../resources/poogle-api'
import { productThumbnail } from '../templates/product-thumbnail'

const buildSlider = (products, slider, type) => {
  const maxItems = 12
  const sliderProducts = products.slice(0, maxItems)

  const sliderItems = sliderProducts.map((item) => {
    const { subscriptionPrice, oneTimePurchasePrice, comparePrice } =
      productPricing(item)

    const badge = getKlevuBadge(item)
    const categoryBadges = getKlevuCategoryBadge(item)

    const priceToShow = subscriptionPrice || oneTimePurchasePrice
    let showComparePrice = false
    const hasPlus = item?.bundle_price?.includes('+') || false

    if (
      comparePrice &&
      comparePrice > priceToShow &&
      comparePrice !== oneTimePurchasePrice
    ) {
      showComparePrice = true
    }

    return productGrid(
      item,
      priceToShow,
      showComparePrice ? comparePrice : null,
      badge,
      categoryBadges,
      type,
      slider.hasClass('add-to-cart-button') ? 'isActive' : null,
      slider.hasClass('enable_reviews') ? 'isActive' : null,
      !item.tags.includes('hide_Price'),
      !item.tags.includes('hide_Reviews'),
      hasPlus
    )
  })

  slider.slick('removeSlide')
  slider.slick(
    'slickAdd',
    sliderItems.map((html) => `<div><div>${html}</div></div>`).join('')
  )
}

const buildSwiperUI = (swiper, products, queryId) => {
  const klevuData = products.queriesById(queryId)?.records
  if (!klevuData?.length) return

  function processProductHtml(html, productsWithHandles) {
    if (!html || html.trim() === '') return

    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = html

    const productHtmlMap = new Map()
    const productItems = tempDiv.querySelectorAll(
      '[data-component="product-item"]'
    )

    productItems.forEach((item) => {
      const handle = item.getAttribute('data-handle')
      if (handle) {
        productHtmlMap.set(handle, item.outerHTML)
      }
    })

    const slides = productsWithHandles
      .map(({ handle }) => {
        if (handle && productHtmlMap.has(handle)) {
          const itemHtml = productHtmlMap.get(handle)
          return `<swiper-slide class="max-w-[164px] mr-3">${itemHtml}</swiper-slide>`
        }
        return null
      })
      .filter(Boolean)
      .join('')

    if (slides) {
      const fragment = document.createDocumentFragment()
      const tempContainer = document.createElement('div')
      tempContainer.innerHTML = slides

      while (tempContainer.firstChild) {
        fragment.appendChild(tempContainer.firstChild)
      }

      swiper.append(fragment)
      swiper[0].initialize()

      if (typeof QuickView !== 'undefined' && QuickView.init) {
        QuickView.init()
      }
    } else {
      console.warn('No matching product HTML found for Klevu results.')
    }
  }

  const klevuProductsWithHandles = klevuData
    .map((product) => {
      const { url } = product
      let handle = null
      try {
        handle = new URL(url).pathname.split('/products/').pop()
      } catch (e) {
        console.error('Error parsing product URL:', url, e)
      }
      return handle ? { handle, product } : null
    })
    .filter(Boolean)

  if (!klevuProductsWithHandles.length) return

  const handles = klevuProductsWithHandles.map((p) => p.handle)
  const searchQuery = handles.map((h) => `handle:${h}`).join(' OR ')
  const url = `/search?view=product-minimal&type=product&q=${encodeURIComponent(
    searchQuery
  )}`

  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          `HTTP error! Status: ${response.status} - ${response.statusText}`
        )
      }
      return response.text()
    })
    .then((html) => {
      processProductHtml(html, klevuProductsWithHandles)
    })
    .catch((error) => {
      console.error('Error fetching or processing product HTML:', error)
    })
}

$('[data-component="klevu-recommended-products-slider"]').each(
  function klevuRecommendedProductsSwiper() {
    const swiper = $(this)
    const id = swiper.attr('data-klevu-recommended-id')

    getProductRecommendations(id).then((products) => {
      buildSwiperUI(swiper, products, 'productRecs')
    })
  }
)

$('[data-component="klevu-slider"]').each(function klevuSwiper() {
  const swiper = $(this)
  const title = swiper.attr('data-title')
  const link = swiper.attr('data-link')
  let filterString = null
  if (link) {
    const lastSlashIndex = link.lastIndexOf('/')
    if (lastSlashIndex !== -1 && lastSlashIndex < link.length - 1) {
      filterString = link.substring(lastSlashIndex + 1)
    }
  }

  const filters = parseFilters(filterString)

  if (title) {
    getKlevuCollection(title, filters).then((products) => {
      buildSwiperUI(swiper, products, 'collection')
    })
  }
})

$('.klevu-collection-section-slider').each((_, sliderEl) => {
  const slider = $(sliderEl)
  const collectionID = slider.data('id').replace(/-/g, ' ')

  getKlevuCollection(collectionID).then((products) => {
    const collectionProducts = products.queriesById('collection')?.records

    buildSlider(collectionProducts, slider, collectionID)
    buildReviews()
    addToCartButton()
    buildLazyLoad()
  })
})

const buildRecommendationSlider = async () => {
  try {
    const res = await getProductRecommendations()
    const result = res.queriesById('productRecs')
    const products = res.queriesById('productRecs').records
    if (products.length === 0) return

    const recommendationClickManager = result.getRecommendationClickSendEvent()
    const slider = $('#recommendation-section-slider')

    $('#product-recommendations').removeClass('hidden')
    buildSlider(products, slider, 'productRecs')
    buildReviews()
    addToCartButton()
    buildLazyLoad()

    $('[data-element="recommended-products"]').each(
      function setupRecommendedProducts() {
        $(this).on('click', function handleClickEvent() {
          const productId = this.getAttribute('data-id')
          const productGroupId = this.getAttribute('data-group-id')
          recommendationClickManager(productId, productGroupId)
        })
      }
    )
  } catch (e) {
    // console.log(e)
  }
}
const buildPoogleRecommendation = async () => {
  try {
    const poogleProducts = await getPoogleRecommendations(
      Pura.product.variants[0].sku
    )
    if (poogleProducts.length === 0) return

    // Extract SKUs from Poogle response
    const skus = poogleProducts.map((p) => p.qr_code).filter(Boolean)
    if (skus.length === 0) return

    // Step 1: Fetch product data for each SKU individually (Shopify doesn't support OR for SKUs)
    const skuPromises = skus.map((sku) => {
      const skuUrl = `/search?view=product-data-by-sku&type=product&q=${encodeURIComponent(
        sku
      )}`
      return fetch(skuUrl)
        .then((res) => (res.ok ? res.json() : null))
        .catch(() => null)
    })

    const skuResponses = await Promise.all(skuPromises)

    // Create a map of SKU to product data
    const skuToProductMap = new Map()
    skuResponses.forEach((skuData) => {
      if (skuData?.products?.length > 0) {
        skuData.products.forEach((product) => {
          product.variants?.forEach((variant) => {
            if (variant.sku) {
              skuToProductMap.set(variant.sku, product)
            }
          })
        })
      }
    })

    // Create ordered list of products based on Poogle match score order
    const orderedProducts = poogleProducts
      .map((p) => skuToProductMap.get(p.qr_code))
      .filter(Boolean)

    if (orderedProducts.length === 0) return

    const slider = $('#poogle-section-slider')
    $('#poogle-recommendations').removeClass('hidden')

    // Use buildSlider to match Klevu styling
    buildSlider(orderedProducts, slider, 'poogle')
    buildReviews()
    addToCartButton()
    buildLazyLoad()
  } catch (e) {
    console.error('Error building Poogle recommendations:', e)
  }
}

if ($('#recommendation-section-slider').length > 0) {
  buildRecommendationSlider()
  buildPoogleRecommendation()
}
